module.exports = "/img/33.d078c5.webp";